import React, { Component } from "react";
import "./Card.scss";

class Card extends Component {
  render() {
    const { title, data, className, cardNo, totalCards } = this.props;

    return (
      <div className={`card ${className || ""}`}>
        {title && (
          <div className="card__header">
            {title}{" "}
            <span className="card__count">
              ({cardNo}/{totalCards})
            </span>
          </div>
        )}
        <div className="card__body">
          {data &&
            data.map((item, index) => (
              <div className="card__item" key={index}>
                <span className="card__label">{item.label}:</span>
                <span className="card__value">{item.value}</span>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default Card;
